import script from "./MyAccountAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccountAddress.vue?vue&type=script&setup=true&lang=js"

import "./MyAccountAddress.vue?vue&type=style&index=0&id=60f6d0e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f6d0e1"]])

export default __exports__